export const DEFAULT_NEEDS_LEVELS = 5;
